export default function () {
  const { localizedStrings } = useLocalizedStrings()
  const ls = localizedStrings.value
  return [
    ls['january'],
    ls['february'],
    ls['march'],
    ls['april'],
    ls['may'],
    ls['june'],
    ls['july'],
    ls['august'],
    ls['september'],
    ls['october'],
    ls['november'],
    ls['december'],
  ]
}
